import React from "react";
import { motion } from "framer-motion";
export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div><h1 className="text-2xl sm:text-3xl font-brand font-bold tracking-tight" style={{ color: "#3B2722" }}>{title}</h1>
        {subtitle && <p className="text-sm mt-1" style={{ color: "#765A4A" }}>{subtitle}</p>}</div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
export function Page({ children }) {
  return <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }} className="max-w-[1400px] mx-auto">{children}</motion.div>;
}
